import { Department } from '../types';
import { ShoppingCart, Calculator, Building2, Warehouse, Store, Receipt, Briefcase, DivideIcon as LucideIcon } from 'lucide-react';

export const getDepartmentLabel = (department: Department | undefined): string => {
  if (!department) return 'Unknown Department';
  
  return department.split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

const departmentIcons: Record<Department, LucideIcon> = {
  'EXECUTIVE': Briefcase,
  'SALES': Store,
  'PURCHASE': ShoppingCart,
  'ACCOUNTS_RECEIVABLE': Receipt,
  'ACCOUNTS_PAYABLE': Calculator,
  'OPERATIONS': Building2,
  'WAREHOUSE': Warehouse
};

export const getDepartmentIcon = (department: Department): LucideIcon => {
  return departmentIcons[department] || Building2;
};

export const departmentList: Department[] = [
  'EXECUTIVE',
  'SALES',
  'PURCHASE',
  'ACCOUNTS_RECEIVABLE',
  'ACCOUNTS_PAYABLE',
  'OPERATIONS',
  'WAREHOUSE'
];

export const validateDepartment = (department: string): department is Department => {
  return departmentList.includes(department as Department);
};

export const getDefaultDepartment = (): Department => 'SALES';